
<template>
  <div>
    <h1>Horarios</h1>
    <div style="margin-bottom: 1.5rem;">
      <button @click="abrirModalAgregar" style="background: #6c757d; color: white; border: none; padding: 0.5rem 1.2rem; border-radius: 4px; font-weight: 600;">+ Agregar Horario</button>
    </div>
    <div class="tabla-responsive">
      <table class="tabla-horarios-principal">
      <thead>
        <tr style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
          <th style="padding: 1rem;">ID</th>
          <th style="padding: 1rem;">Hora Inicio</th>
          <th style="padding: 1rem;">Hora Final</th>
          <th style="padding: 1rem;">Fecha Creación</th>
          <th style="padding: 1rem; text-align:center;">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="horario in horarios" :key="horario.id" style="border-bottom: 1px solid #e9ecef;">
          <td style="padding: 0.8rem; font-weight: 600;">{{ horario.id }}</td>
          <td style="padding: 0.8rem;">{{ horario.horaInicio }}</td>
          <td style="padding: 0.8rem;">{{ horario.horaFinal }}</td>
          <td style="padding: 0.8rem;">{{ formatFecha(horario.fechacreacion) }}</td>
          <td style="padding: 0.8rem; text-align:center;">
            <button @click="abrirModalEditar(horario)" style="background: #ffc107; color: #333; border: none; padding: 0.4rem 1rem; border-radius: 4px; margin-right: 0.5rem;">Editar</button>
            <button @click="eliminarHorario(horario.id)" style="background: #dc3545; color: white; border: none; padding: 0.4rem 1rem; border-radius: 4px;">Eliminar</button>
          </td>
        </tr>
        <tr v-if="horarios.length === 0">
          <td colspan="5" style="text-align:center; padding: 2rem; color: #6c757d; font-style: italic;">No hay horarios registrados</td>
        </tr>
      </tbody>
      </table>
    </div>
    <div style="margin-top:1rem;">
      <button :disabled="page === 1" @click="cambiarPagina(page-1)">Anterior</button>
      Página {{ page }} de {{ totalPages }}
      <button :disabled="page === totalPages" @click="cambiarPagina(page+1)">Siguiente</button>
    </div>

    <!-- Modal Editar -->
    <div v-if="showModalEditar" class="modal">
      <div class="modal-content">
        <h3>Editar Horario</h3>
        <label>Hora Inicio
          <input v-model="horarioEditar.horaInicio" type="time" />
        </label>
        <label>Hora Final
          <input v-model="horarioEditar.horaFinal" type="time" />
        </label>
        <button @click="guardarEdicion">Guardar</button>
        <button @click="cerrarModalEditar" style="margin-left:1rem;">Cancelar</button>
      </div>
    </div>

    <!-- Modal Agregar -->
    <div v-if="showModalAgregar" class="modal">
      <div class="modal-content">
        <h3>Agregar Horario</h3>
        <label>Hora Inicio
          <input v-model="horarioNuevo.horaInicio" type="time" />
        </label>
        <label>Hora Final
          <input v-model="horarioNuevo.horaFinal" type="time" />
        </label>
        <button @click="guardarNuevo">Agregar</button>
        <button @click="cerrarModalAgregar" style="margin-left:1rem;">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetch } from '../restapi.js';

export default {
  name: 'HorariosView',
  data() {
    return {
      horarios: [],
      total: 0,
      page: 1,
      pageSize: 10,
      showModalEditar: false,
      showModalAgregar: false,
      horarioEditar: null,
      horarioNuevo: {
        horaInicio: '',
        horaFinal: ''
      }
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    }
  },
  methods: {
    async fetchHorarios() {
      const params = `?page=${this.page}&pageSize=${this.pageSize}`;
      try {
        const response = await apiFetch(`/horarios/ObtenerHorariosPaginado${params}`, {
          headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const data = await response.json();
        this.horarios = data.horarios || [];
        this.total = data.total || 0;
      } catch (err) {
        this.horarios = [];
        this.total = 0;
        if (this.$toast) this.$toast.error('Error al obtener horarios');
      }
    },
    abrirModalEditar(horario) {
      this.horarioEditar = { ...horario };
      this.showModalEditar = true;
    },
    cerrarModalEditar() {
      this.showModalEditar = false;
      this.horarioEditar = null;
    },
    async guardarEdicion() {
      if (!this.horarioEditar) return;
      try {
        const response = await apiFetch(`/horarios/ModificarHorario/${this.horarioEditar.id}`, {
          method: 'PATCH',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            horaInicio: this.horarioEditar.horaInicio,
            horaFinal: this.horarioEditar.horaFinal
          })
        });
        if (!response.ok) throw new Error('Error al editar horario');
        const data = await response.json();
        this.cerrarModalEditar();
        this.fetchHorarios();
        if (this.$toast) this.$toast.success(data.message || 'Horario editado correctamente');
      } catch (err) {
        if (this.$toast) this.$toast.error('Error al editar horario');
      }
    },
    abrirModalAgregar() {
      this.horarioNuevo = { horaInicio: '', horaFinal: '' };
      this.showModalAgregar = true;
    },
    cerrarModalAgregar() {
      this.showModalAgregar = false;
    },
    async guardarNuevo() {
      try {
        const response = await apiFetch('/horarios/AgregarHorario', {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            horaInicio: this.horarioNuevo.horaInicio,
            horaFinal: this.horarioNuevo.horaFinal
          })
        });
        if (!response.ok) throw new Error('Error al agregar horario');
        const data = await response.json();
        this.cerrarModalAgregar();
        this.fetchHorarios();
        if (this.$toast) this.$toast.success(data.message || 'Horario agregado correctamente');
      } catch (err) {
        if (this.$toast) this.$toast.error('Error al agregar horario');
      }
    },
    async eliminarHorario(id) {
      if (confirm('¿Seguro que deseas eliminar este horario?')) {
        try {
          const response = await apiFetch(`/horarios/EliminarHorario/${id}`, {
            method: 'DELETE',
            headers: { 'accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
          });
          if (!response.ok) throw new Error('Error al eliminar horario');
          const data = await response.json();
          this.fetchHorarios();
          if (this.$toast) this.$toast.success(data.message || 'Horario eliminado correctamente');
        } catch (err) {
          if (this.$toast) this.$toast.error('Error al eliminar horario');
        }
      }
    },
    cambiarPagina(nuevaPagina) {
      this.page = nuevaPagina;
      this.fetchHorarios();
    },
    formatFecha(fecha) {
      if (!fecha) return '';
      // Para fechas que incluyen hora, mantenemos el comportamiento original
      // ya que probablemente necesitamos mostrar la hora también
      return new Date(fecha).toLocaleString();
    }
  },
  mounted() {
    this.fetchHorarios();
    // Configurar scroll horizontal
    this.$nextTick(() => {
      const tabla = document.querySelector('.tabla-responsive');
      if (tabla) {
        tabla.addEventListener('wheel', (e) => { if (tabla.scrollWidth > tabla.clientWidth) { e.preventDefault(); tabla.scrollLeft += e.deltaY; } }, { passive: false });
        let isDown = false, startX, scrollLeft;
        tabla.addEventListener('mousedown', (e) => { isDown = true; startX = e.pageX - tabla.offsetLeft; scrollLeft = tabla.scrollLeft; tabla.style.cursor = 'grabbing'; });
        tabla.addEventListener('mouseleave', () => { isDown = false; tabla.style.cursor = 'grab'; });
        tabla.addEventListener('mouseup', () => { isDown = false; tabla.style.cursor = 'grab'; });
        tabla.addEventListener('mousemove', (e) => { if (!isDown) return; e.preventDefault(); const x = e.pageX - tabla.offsetLeft; tabla.scrollLeft = scrollLeft - (x - startX) * 2; });
      }
    });
  }
};
</script>

<style scoped>
/* --- TABLA RESPONSIVA --- */
.tabla-responsive {
  width: 100% !important; overflow-x: auto !important; overflow-y: hidden !important;
  -webkit-overflow-scrolling: touch; margin-bottom: 1.5rem; box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border-radius: 8px; max-width: 100vw !important; display: block !important; position: relative;
  scrollbar-width: auto; scrollbar-color: #4a90e2 #e0e0e0; cursor: grab;
}
.tabla-responsive:active { cursor: grabbing; }
.tabla-responsive::-webkit-scrollbar { height: 12px; }
.tabla-responsive::-webkit-scrollbar-track { background: #e0e0e0; border-radius: 6px; }
.tabla-responsive::-webkit-scrollbar-thumb { background: #4a90e2; border-radius: 6px; }
.tabla-responsive::after { content: "← Desplázate horizontalmente →"; position: absolute; bottom: -25px; left: 50%; transform: translateX(-50%); font-size: 12px; color: #666; opacity: 0.7; }
@media (min-width: 1201px) { .tabla-responsive::after { display: none; } }
.tabla-horarios-principal { width: 800px !important; min-width: 800px !important; table-layout: fixed !important; }
.modal {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  min-width: 320px;
  max-width: 90vw;
}
.modal-content label {
  display: block;
  margin-top: 1rem;
}
.modal-content input {
  width: 100%;
  padding: 0.5rem;
  margin-top: 0.2rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.modal-content button {
  margin-top: 1.2rem;
}
</style>
